import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import DataTable from "../components/DataTable";
import SeverityBadge from "../components/SeverityBadge";
import { Badge } from "../components/ui/badge";
import { formatIDR, formatPercent } from "../lib/format";

export default function GroupObligors() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/group-obligors").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load once on mount

  return (
    <div className="p-8 max-w-[1600px] mx-auto" data-testid="groups-page">
      <PageHeader title="Group Obligor" subtitle={`${data.length} group obligor dikonsolidasi`} testId="groups-header" />
      {loading ? (
        <div className="text-sm text-muted-foreground">Memuat…</div>
      ) : (
        <DataTable
          testId="groups-table"
          searchKeys={["group_id", "group_name"]}
          columns={[
            { header: "Group ID", cell: (r) => <span className="mono">{r.group_id}</span> },
            { header: "Nama Group", cell: (r) => (
              <button className="font-medium text-left hover:underline" onClick={() => navigate(`/groups/${r.group_id}`)} data-testid={`group-${r.group_id}-link`}>{r.group_name}</button>
            ) },
            { header: "Anggota", cell: (r) => <span className="mono">{r.member_count}</span>, align: "right" },
            { header: "Group Limit", cell: (r) => formatIDR(r.group_limit, { compact: true }), align: "right" },
            { header: "Utilized", cell: (r) => formatIDR(r.total_utilized_limit, { compact: true }), align: "right" },
            { header: "Eksposur", cell: (r) => formatIDR(r.total_exposure, { compact: true }), align: "right" },
            { header: "Available", cell: (r) => formatIDR(r.available_limit, { compact: true }), align: "right" },
            { header: "Util %", cell: (r) => (
              <span className={`mono ${(r.total_exposure / (r.group_limit || 1)) > 0.9 ? "text-[#D0021B] font-bold" : ""}`}>
                {formatPercent(r.total_exposure / (r.group_limit || 1))}
              </span>
            ), align: "right" },
            { header: "Status", cell: (r) => r.breach ? <SeverityBadge severity="critical">BREACH</SeverityBadge> : <Badge variant="outline">OK</Badge> },
          ]}
          data={data}
        />
      )}
    </div>
  );
}
